import { useStore } from '../lib/store';

/** Reactive auth flag derived from the single store user the auth hook writes. */
export function useIsAuthenticated(): boolean {
  return useStore((state) => !!state.supabaseUser);
}
